/**
 * 配列(または連想配列)のキーの配列を取得する
 */
module.exports = function(ary){
    var rtn = [];
    for(var key in ary){
        rtn.push(key);
    }
    return rtn;
}
